
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
export default class CardWrapper extends Vue {
  @Prop({ type: String, default: "" }) topText!: string;
}
